import UploadForm from "../../components/UploadForm/UploadForm";
import "./UploadPage.scss";
const UploadPage = () => {
  return (
    <main className="upload-page">
      <UploadForm />
    </main>
  );
};

export default UploadPage;
